import React from 'react';
import styles from './HowWeWorkSection.module.css';
import { FaTerminal } from 'react-icons/fa';
import { isSmallScreen } from '../../../utils/screen';

interface HowWeWorkSectionProps {
    title: React.ReactNode;
    steps: Array<{
        title: React.ReactNode;
        description: React.ReactNode[];
    }>;
}

const HowWeWorkSection: React.FC<HowWeWorkSectionProps> = ({ title, steps }) => {
    return (
        <section className={styles.section}>
            <div className={styles.container}>
                <div className={styles.leftColumn}>
                    <div className={styles.stickyContent}>
                        <FaTerminal size={isSmallScreen() ? 44 : 54} />
                        <h2 className={styles.title}>{title}</h2>
                    </div>
                </div>
                <div className={styles.rightColumn}>
                    <div className={styles.cardsContainer}>
                        {steps.map((step, index) => (
                            <div key={index} className={styles.card}>
                                <h3 className={styles.cardTitle}>{step.title}</h3>
                                <div className={styles.cardDescriptionContainer}>
                                    {step.description.map((paragraph, pIndex) => (
                                        <p key={pIndex} className={styles.cardDescription}>
                                            {paragraph}
                                        </p>
                                    ))}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default HowWeWorkSection; 